import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import { API } from "../../../../API";
import { isAutheticated } from "../../../auth/authhelper";
import Footer from "../../Footer";

function TVShowSeason(props) {
  const { tvshowId } = useParams();
  const { token } = isAutheticated();
  const [season, setSeason] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [Loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API}/api/tvshow/view_tvshow/${tvshowId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const userdata = response.data;
        setSeason(userdata?.season);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // Calculate total pages
  const totalPages = Math.ceil(season.length / itemsPerPage);

  // Get the items for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = season.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0">TV Shows - Seasons</h4>
              </div>
            </div>
          </div>
          {/* Table */}
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive table-shoot">
                    <table className="table table-centered table-nowrap mb-0">
                      <thead className="thead-light">
                        <tr>
                          <th>Season</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Loading ? (
                          <tr>
                            <td colSpan="10" align="center">
                              <div style={{ fontSize: "1.2rem", fontWeight: "bold", color: "#007bff" }}>
                                Loading...
                              </div>
                            </td>
                          </tr>
                        ) : currentItems.length > 0 ? (
                          currentItems.map((data, i) => (
                            <tr key={i}>
                              <td>Season {data.number}</td>
                              <td>
                                <Link to={`/language/season/view/${data._id}`}>
                                  <button
                                    type="button"
                                    className="btn btn-info btn-sm waves-effect waves-light btn-table ml-2"
                                  >
                                    View Episode
                                  </button>
                                </Link>
                                <Link to={`/language/season/edit/${data._id}`}>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm waves-effect waves-light btn-table ml-2"
                                  >
                                    Edit
                                  </button>
                                </Link>
                                <button
                                  type="button"
                                  onClick={() => {
                                    if (window.confirm("Do you want to delete?")) {
                                      axios
                                        .delete(`${API}/api/tvshow/delete_season/${data._id}`, {
                                          headers: {
                                            Authorization: `Bearer ${token}`,
                                          },
                                        })
                                        .then(() => {
                                          swal({
                                            title: "Season deleted Successfully!",
                                            icon: "success",
                                          });
                                          setSeason((prev) => prev.filter((s) => s._id !== data._id));
                                        })
                                        .catch(console.error);
                                    }
                                  }}
                                  className="btn btn-danger btn-sm waves-effect waves-light btn-table ml-2"
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center py-4">
                              No season Found. Please add New season to display here.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  {totalPages > 0 &&
                    (<>

                      <div className='col-sm-12 col-md-6 mb-20'>

                        <div
                          className='dataTables_info'
                          id='datatable_info'
                          role='status'
                          aria-live='polite'>
                          Showing 1 to {currentPage} of {season?.length} entries
                        </div>
                      </div>
                      <div className="dataTables_paginate paging_simple_numbers float-right">
                        <ul className="pagination">
                          <li
                            className={`paginate_button page-item previous ${currentPage === 1 ? "disabled" : ""
                              }`}
                            onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
                          >
                            <a href="#" className="page-link">
                              Previous
                            </a>
                          </li>
                          {Array.from({ length: totalPages }, (_, i) => (
                            <li
                              key={i}
                              className={`paginate_button page-item ${currentPage === i + 1 ? "active" : ""
                                }`}
                              onClick={() => handlePageChange(i + 1)}
                            >
                              <a href="#" className="page-link">
                                {i + 1}
                              </a>
                            </li>
                          ))}
                          <li
                            className={`paginate_button page-item next ${currentPage === totalPages ? "disabled" : ""
                              }`}
                            onClick={() => currentPage < totalPages && handlePageChange(currentPage + 1)}
                          >
                            <a href="#" className="page-link">
                              Next
                            </a>
                          </li>
                        </ul>
                      </div>
                    </>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default TVShowSeason;
